module.exports = __webpack_public_path__ + "static/WEDDING E&M-466-f91e9322548e4c5426c5b70dfdd1d5ca.jpg";